import { Container, Row, Col } from 'react-bootstrap';
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import { useTranslation } from 'react-i18next';
import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import toast, { Toaster } from 'react-hot-toast';

export const Contact = () => {
  const [t] = useTranslation('global');
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_rwgt6nf', 'template_wnalsxx', form.current, {
        publicKey: '9aQtyZRQ4BY_JATF0',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          toast.success('Successfully toasted!')
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="justify-content-center align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div className={isVisible ? 'animate__animated animate__fadeIn' : ''}>
                  <h2 className="text-center">{t('contact.title')}</h2>
                  <form ref={form} onSubmit={sendEmail}>
                    <Row>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          type="text"
                          name="user_first_name"
                          placeholder="First Name"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          name="user_last_name"
                          type="text"
                          placeholder="Last Name"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          name="user_email"
                          type="email"
                          placeholder="Email Address"
                        />
                      </Col>
                      <Col size={12} sm={6} className="px-1">
                        <input
                          name="user_phone"
                          type="tel"
                          placeholder="Phone No."
                        />
                      </Col>
                      <Col size={12} className="px-1 text-center">
                        <textarea
                          rows="6"
                          name="message"
                          placeholder="Message"
                        />
                           <button type="submit" value="Send">
                             <span>{t('contact.button')}</span>
                           </button>
                        <Toaster />
                      </Col>
                    </Row>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
